import React from "react";
import { IoVideocamOutline } from "react-icons/io5";
import dentalImplants_img from "../../secondAssets/Images/dental-implants-img.jpeg"

const DentalImplants = (props) => {
    const { selectedLanguage } = props;
    return (
        <div className="dentalImplant-main">
            <div className="DentalImplants-container">
                <div data-aos="fade-right"
                data-aos-easing="ease-out-bounce"
                data-aos-delay="300"
                data-aos-duration="2000">
                    <IoVideocamOutline className="meet_icon"/>
                    <h1>{selectedLanguage?.txt_dental_implants_offer}</h1>
                    <p>{selectedLanguage?.txt_implants_stable_fit}</p>
                    <button>{selectedLanguage?.txt_learn_more}</button>
                </div>
                <div data-aos="fade-left"
                data-aos-easing="ease-out-bounce"
                data-aos-delay="300"
                data-aos-duration="2000">
                    <img src={dentalImplants_img} alt="dentalImplants_img" />
                </div>
            </div>
        </div>
    )
}
export default DentalImplants